import { useContext } from "react"
import { Button, StackView, Text } from "@planningcenter/tapestry-react"
import { capitalize } from "utils/helpers"
import { bool, number, oneOfType, string } from "prop-types"
import AccountCenterSearch from "components/admin/account_center_search/account_center_search"
import RegisterableContext from "components/admin/registerable/context"

const Attendee = ({ id, selectionName, placeholder = false }) => {
  const { registerable } = useContext(RegisterableContext)

  const handleAttendeePersonSelect = ({ account_center_id }) => {
    if (!placeholder) {
      registerable.update({
        attendees_attributes: [
          {
            id,
            person_id: account_center_id
          }
        ],
        responsible_person_id: registerable.responsiblePersonId || account_center_id
      })
    }
  }

  const attendee = registerable.attendees.find(attendee => attendee.id === parseInt(id))

  const onClear = () => {
    handleAttendeePersonSelect({ account_center_id: null })
  }

  const SelectedPersonDisplay = () => (
    <>
      <Text>{capitalize(attendee?.person?.name)}</Text>
      <Button
        icon={{ name: "general.x" }}
        title="Remove this attendee"
        theme="destroy"
        variant="naked"
        onClick={onClear}
      />
    </>
  )

  return (
    <StackView
      axis="horizontal"
      alignment="center"
      distribution="space-between"
      gap={2}
      position="relative"
    >
      <label htmlFor={`${id}_label`} className="mb-0">
        {selectionName}
      </label>
      <StackView axis="horizontal" alignment="center" distribution="end" spacing={1}>
        {attendee?.personId ? (
          <SelectedPersonDisplay />
        ) : (
          <AccountCenterSearch
            inputProps={{
              placeholder: "Search for someone"
            }}
            menuProps={{
              style: { zIndex: 3 }
            }}
            onSelect={handleAttendeePersonSelect}
          />
        )}
      </StackView>
    </StackView>
  )
}

Attendee.propTypes = {
  id: oneOfType([number, string]).isRequired,
  selectionName: string.isRequired,
  placeholder: bool
}

export default Attendee
